// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_7a3fb80146--carousel--f7nUw"};